import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorEligibilityRuleHasDiscreteUserField } from '../editor-eligibility-rule/editor-eligibility-rule-has-discrete-user-field.model';


@Component({
    selector: 'eas-editor-eligibility-rule-value-has-discrete-user-field',
    templateUrl: './editor-eligibility-rule-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleValueHasDiscreteUserFieldComponent implements OnInit, OnChanges, OnDestroy {
  @Input() rule: EditorEligibilityRuleHasDiscreteUserField;
  @Input() affirmative: boolean;

  private destroyed$ = new Subject<void>();

  discreteUserFieldNamesWithCategoryNames: { id: string, name: string, categoryNames: { id: string, name: string }[] }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.discreteUserFieldNamesWithCategoryNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        discreteUserFieldNamesWithCategoryNames => {
          this.discreteUserFieldNamesWithCategoryNames = discreteUserFieldNamesWithCategoryNames;
          this.value = this.getValue();
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.discreteUserFieldNamesWithCategoryNames === undefined) {
      return $localize `Not available`;
    }

    const userField = this.rule.getUserFieldName(this.discreteUserFieldNamesWithCategoryNames);
    const userFieldValue = this.rule.getUserFieldCategoriesAsString(this.discreteUserFieldNamesWithCategoryNames);
    return this.affirmative
      ? $localize `Candidate has the user field ${userField} with value ${userFieldValue}`
      : $localize `Candidate has NOT the user field ${userField} with value ${userFieldValue}`;
  }
}
